import { createModel } from 'xstate/lib/model';

import baseEvents from 'common/bento/config/baseEvents';
import { ModuleDataWithBootstrap } from 'common/bento/lib/bootstrap/types';

import { NativeFourthlineQesOutcome } from '../../Identity/machine/model';
import { QesModuleDataQuery } from '../graphql/queries/qesModuleData.gql';
import { Service } from './services';

export interface SignatureContext {
  token: string;
}

type QesModuleData = QesModuleDataQuery &
  ModuleDataWithBootstrap & {
    companyProfileId: string;
  };

export const initialContext: {
  getModuleData: () => QesModuleData;
  signatureContext: SignatureContext | null;
} = {
  getModuleData: () => {
    throw new Error('NOT_IMPLEMENTED');
  },
  signatureContext: null,
};

const model = createModel(initialContext, {
  events: {
    ...baseEvents,

    'done.invoke.completeNativeFourthlineWorkflow': (
      data: NativeFourthlineQesOutcome,
    ) => ({
      data,
    }),

    'error.platform.startSignature': (data: Error) => ({ data }),

    INVALID_IDENTITY_PROVIDER_ERROR: () => ({}),
    RESTART_SIGNATURE: () => ({}),

    [`done.invoke.${Service.StartSignature}` as const]: (
      data: SignatureContext,
    ) => ({
      data,
    }),
  },
});

export default model;

export type Context = typeof initialContext;
export type Model = typeof model;
